export default __webpack_public_path__ + "static/media/Mahakaleshwar-Temple.fa557bfb.jpg";